export default __webpack_public_path__ + "static/media/login-bk.4ba8d15f.jpg";